









































































































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext,
  reactive
} from "@vue/composition-api";
import SnackBar from "../../../Common/SnackBar.vue";
import { isNullOrEmpty } from "@/methods/validation";
import WalletKey from "@/components/wallet-key";
import MemberKey from "@/components/member-key";
import SnackbarKey from "@/components/snackbar-key";
import router from "@/router";
import KyodaiChargeKey from "@/components/kyodai-charge-key";

interface SnackBar {
  [prop: string]: any;
}

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }
    // storeを注入
    const snackbarStore = inject(SnackbarKey);
    if (!snackbarStore) {
      throw new Error(`${snackbarStore} is not provided`);
    }

    const kyodaiChargeStore = inject(KyodaiChargeKey);
    if (!kyodaiChargeStore) {
      throw new Error(`${KyodaiChargeKey} is not provided`);
    }
    const walletStore = inject(WalletKey);
    if (!walletStore) {
      throw new Error(`${WalletKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const loadedFlag = ref<boolean>(false);
    const accessToken = computed(() => globalStore.auth.token);
    const member = computed(() => memberStore.member);
    const accountForm = ref<HTMLFormElement>();
    const amount = ref<any>(null);
    const lowerLimitAmount = ref<any>(null);
    const balanceAmount = ref<any>(null);
    const walletList = computed(() => walletStore.walletList);
    const kyodaiChargeList = computed(() => kyodaiChargeStore.kyodaiChargeList);
    const chargeCount = computed(() => kyodaiChargeStore.chargeCount);

    // バリデーションルール
    const requireRule = (value: string) => !!value || "必須入力です。";
    const upperLimitRule = (value: string) =>
      value <= upperLimit.value || "一度のチャージ限度額を超えています。";
    const lowerLimitRule = (value: string) =>
      value >= lowerLimitAmount.value ||
      "一度のチャージ下限額を下回っています。";

    // 残高取得
    const getBalance = () => {
      let list = walletStore.walletList;
      let company_wallet_data = list.filter(
        (e: any) =>
          e.company_code_item.internal_value == kyodaiChargeStore.companyCode
      );
      if (company_wallet_data) {
        return company_wallet_data[0]["account_balance"];
      } else {
        return 0;
      }
    };

    // 上限金額
    const upperLimit = reactive<any>({
      // 上限金画面表示用
      display: "",
      // 上限金
      value: 0,
      // 手数料
      commission: 0
    });

    // 残高が足りるかどうか確認
    const checkBalance = () => {
      let balance = getBalance();
      if (balance < Number(upperLimit.commission) + Number(amount.value)) {
        return true;
      } else {
        return false;
      }
    };

    const confirm = async () => {
      // ここでバリデーションチェック
      if (!accountForm.value) return;
      const validResult = accountForm.value.validate();
      if (validResult) {
        if (Number(chargeCount.value) >= 3) {
          displaySnackbar("1日にチャージできる回数は3回までです。");
          return;
        }
        if (checkBalance()) {
          displaySnackbar("残高が足りません。");
          return;
        }
        // 値を全てStoreに保存して確認画面に遷移する
        kyodaiChargeStore.setAmount(amount.value);
        kyodaiChargeStore.setUserLastName(member.value.name_1);
        kyodaiChargeStore.setUserFirstName(member.value.name_2);
        kyodaiChargeStore.setPhoneNumber(member.value.phone_number);
        kyodaiChargeStore.setMailAddress(member.value.mail_address);
        kyodaiChargeStore.setBirthday(member.value.birthday);
        // チャージ確認画面に遷移する
        context.root.$router.push({name: "KyodaiChargeRequestConfirm"});
      } else {
        displaySnackbar("入力項目に誤りがあります。");
      }
    };

    const setCompanyInfos = async (e: any) => {
      await kyodaiChargeStore.setCompanyInfo(e);
      // 手数料を取得する
      await kyodaiChargeStore
        .getKyodaiChargeCommission(kyodaiChargeStore.companyCode)
        .then((response: any) => {
          if (response.status != 200) {
            displaySnackbar(kyodaiChargeStore.errorMessage);
          }
        });
      // 残高を取得する
      let balance = getBalance();
      upperLimit.display =
        kyodaiChargeStore.upperLimitAmount > balance
          ? balance
          : kyodaiChargeStore.upperLimitAmount;
      upperLimit.display = Number(upperLimit.display).toLocaleString();
      upperLimit.value = kyodaiChargeStore.upperLimitAmount;
      upperLimit.commission = kyodaiChargeStore.commission;
      lowerLimitAmount.value = kyodaiChargeStore.lowerLimitAmount;
      balanceAmount.value = balance;
    };

    // 登録ボタン押下後のスナックバー制御
    const snackbarInfo = reactive<SnackBar>({
      display: false,
      error: false,
      message: ""
    });

    // 2.5秒間のスナックバー表示させる
    const displaySnackbar = (message: string) => {
      snackbarInfo.message = message;
      snackbarInfo.error = true;
      snackbarInfo.display = true;
      window.scrollTo({
        top: window.innerHeight,
        behavior: "smooth"
      });
      // 2.5秒後にスナックバーを初期化する
      setTimeout(() => {
        snackbarInfo.display = false;
        snackbarInfo.error = false;
        snackbarInfo.message = "";
      }, 2500);
    };

    onMounted(async () => {
      loadedFlag.value = true;
      memberStore.setAuthorizationHeader(accessToken.value);
      walletStore.setAuthorizationHeader(accessToken.value);
      await memberStore.getMember();
      await kyodaiChargeStore.getKyodaiAccount(member.value.member_no);
      await walletStore.getWalletList();
      await kyodaiChargeStore.getWhiteListCompany(walletStore.companyCodeList);
      await kyodaiChargeStore.getKyodaiChargeCompanies(walletStore.walletList);
      await kyodaiChargeStore.getChargeHistoryCounts(
        String(Math.floor(member.value.member_no))
      );
      kyodaiChargeStore.clearCompanyInfo();
      loadedFlag.value = false;

      // 登録後の遷移であればスナックバーを出す。
      const snackbar = snackbarStore.snackbar;
      if (snackbar.display) {
        snackbarInfo.display = snackbar.display;
        snackbarInfo.message = snackbar.message;
        snackbarInfo.error = snackbar.error;
      }
    });

    return {
      loadedFlag,
      member,
      kyodaiChargeStore,
      snackbarInfo,
      setCompanyInfos,
      isNullOrEmpty,
      requireRule,
      upperLimitRule,
      confirm,
      accountForm,
      amount,
      upperLimit,
      lowerLimitRule,
      balanceAmount,
      walletList,
      kyodaiChargeList
    };
  },
  components: { SnackBar }
});
